<div class="ui-g-12">
  <app-kontable
    #table
    title = "{{ 'customerSetBuilder.executionsHistorical' | translate }}"
    [columns]="[
      'id_query',
      'version',
      'job_id',
      {field: 'expected_execution_date', title: 'customerSetBuilder.expectedExecutionDateTime', type: 'date', filterType: dateFilter},
      {field: 'ts_dataset_execution', title: 'customerSetBuilder.effectiveDateTime', type: 'date', filterType: dateFilter},
      {field: 'result_obtained', title: 'customerSetBuilder.recordCount', filterType: noFilter},
      {field: 'cluster_head_desc', title: 'customers.ext_clusters'},
      {field: 'ts_cluster_execution', title:'customerSetBuilder.clusterExecution', type: 'date', filterType: dateFilter},
      {field: 'descr_errore', title: 'customerSetBuilder.execState', filterType: noFilter}
    ]"
    [titles] = "[
      'customerSetBuilder.queryId',
      'customerSetBuilder.queryVersion',
      'customerSetBuilder.jobId',
      'customerSetBuilder.queryState',
      'customerSetBuilder.recursiveQuery'
    ]"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showReport]="false"
    [showInfoButton]="false"
    [service]="customerSetBuilderService"
    [paginationType]="paginationType"
    [additionalRowCommands]="customRow">
    <ng-template #recursive data-testid="recursive" let-row>
      <span *ngIf="row.flg_recursive === '1' ">{{'common.yes' | translate}}</span>
    </ng-template>
    <ng-template #customRow data-testid="customRow" let-row>
      <p-button label="" pTooltip="{{ 'common.details' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="openDetailDialog(row)"></p-button>
    </ng-template>
  </app-kontable>
</div>

<p-dialog
  class="detail-dialog"
  *ngIf="showDetail"
  [(visible)]="showDetail"
  [modal]="true"
  header="{{ 'customerSetBuilder.importDetail' | translate }}"
  [width]="500"
  [minHeight]="150"
  [draggable]="false"
  [responsive]="true"
  [resizable]="false"
  (onHide)="closeDetailDialog()">
  <div>
    <ul>
      <li><b>{{'customerSetBuilder.rowRead' | translate }}:</b> {{actualRow.pl_read}}</li>
      <li><b>{{'customerSetBuilder.rowWritten' | translate }}:</b> {{actualRow.pl_write + actualRow.pl_update}}</li>
      <li><b>{{'customerSetBuilder.rowDiscarded' | translate }}:</b> {{actualRow.pl_read - (actualRow.pl_write + actualRow.pl_update)}}</li>
      <li><b>{{'customerSetBuilder.stateImport' | translate }}:</b> {{actualRow.pl_stato_job}}</li>
    </ul>
  </div>
  <div *ngIf="actualRow.pl_flg_state === 'E' " class="padd-top">
    <b>{{'common.error' | translate }}: </b> <br>
    <p class="error">{{actualRow.pl_error}}</p>
  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-execution-list/customer-set-execution-list.component.html